import * as yup from "yup";
import { validationConfirmNewPasswordL, validationEmailField, validationNewPassword, validationNotEmpty, } from "./defaultValidations";

export default yup.object({
    email: validationEmailField("Email"),
    // oldPassword: validationNewPassword("Current Password"),
    password: validationNewPassword("Password"),
    confirmPassword: validationConfirmNewPasswordL("Confirm Password"),
});